import React from 'react'
import { useOutsideClick } from 'rooks'
import { Tooltip } from '@mobi/component-library/Common/V2/Tooltip'
import { useOnboardingTooltips } from '@core/Areas/FollowMe/hooks/useOnboardingTooltips'
import { Button } from '@mobi/component-library/Common/V2'
import { FollowButtonLocation } from '../types'

export const FollowButtonComponent: React.FC<{
  isPending: boolean
  handleFollowClick: () => void
  location: FollowButtonLocation
}> = ({ isPending, handleFollowClick, location }) => {
  const followTooltipRef = React.useRef<HTMLButtonElement>(null)
  const { currentTooltipId, onDismissed } = useOnboardingTooltips('bet-loop-follow-user')
  const shouldShowFollowTooltip = currentTooltipId === 'bet-loop-follow-user'
  useOutsideClick(followTooltipRef, () => {
    if (shouldShowFollowTooltip) onDismissed('bet-loop-follow-user')
  })

  return (
    <Button
      size='sm'
      color={location === 'profile' ? 'primary' : 'secondary_color'}
      disabled={isPending}
      onClick={handleFollowClick}
      ref={followTooltipRef}
    >
      Follow
      {shouldShowFollowTooltip && (
        <Tooltip
          color='blue'
          triggerElRef={followTooltipRef}
          tooltipId='bet-loop-follow-user'
          hasTooltipBeenSeen={() => false}
          shouldHideCrossIcon
          shouldOnlyRenderSingleInstance={true}
          isHidden={isPending}
          offsetYPx={9}
          offsetXPx={-42}
          flipElement={true}
          onDismissed={() => onDismissed('bet-loop-follow-user')}
        >
          <div>Press follow to</div>
          <div>personalise your feed</div>
        </Tooltip>
      )}
    </Button>
  )
}
